import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import JourneyPage from '@src/pages/journey-explorer';
import { ManagementPage, DimensionsEditing, EventsEditing } from '@src/pages/management';
import { TempFunnelAnalysis, SavedFunnelAnalysis } from '@src/pages/funnel-analysis';

const Router = () => (
  <Routes>
    <Route path={`/paths`} element={<JourneyPage />} />
    <Route path={`/paths/shared/:id`} element={<JourneyPage />} />

    <Route path={`/management`} element={<ManagementPage />}>
      <Route path={`dimensions/:id?`} element={<DimensionsEditing />} />
      <Route path={`events/:id?`} element={<EventsEditing />} />
    </Route>

    {/* Funnel analysis dashboard: temporary dashboard */}
    <Route path={`/funnels/temp/:id?`} element={<TempFunnelAnalysis />} />

    {/* Funnel analysis dashboard: saved dashboard */}
    <Route path={`/funnels/saved/:id`} element={<SavedFunnelAnalysis />} />

    {/* Redirect to journey explorer for any other routes */}
    <Route path={`*`} element={<Navigate to={'/paths'} />} />
  </Routes>
);

export default Router;
